module.exports = __webpack_public_path__ + "img/game2.32a22a7d.png";